<dashboard-header/>

<main class="flex-1 py-5 md:py-10" role="main">
  <div class="container max-w-none">
    <router-outlet/>
  </div>
</main>

<footer class="text-right px-2.5 md:px-5 pb-2.5 md:pb-5 pt-5 md:pt-10 text-slate-400 text-sm">
  Powered by Emsys Design LLC &copy; {{currentYear}}
</footer>

<vm-teleport name="dropdown"/>
